/**
 * @generated SignedSource<<88e7e7050f2294274aa45f99a21b53f7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type PortfolioProjectTextCoverStyle = "COLOR_BLACK" | "COLOR_BLUE" | "COLOR_GREEN" | "COLOR_ORANGE" | "COLOR_PURPLE" | "COLOR_SALMON" | "COLOR_WATERMELON" | "COLOR_WHITE" | "COLOR_YELLOW" | "SHAPE_COINS_DARK" | "SHAPE_COINS_LIGHT" | "SHAPE_COLLABORATION_DARK" | "SHAPE_COLLABORATION_LIGHT" | "SHAPE_FOCUS_DARK" | "SHAPE_FOCUS_LIGHT" | "SHAPE_GAIN_DARK" | "SHAPE_GAIN_LIGHT" | "SHAPE_STAIRS_DARK" | "SHAPE_STAIRS_LIGHT" | "SHAPE_WAVE_DARK" | "SHAPE_WAVE_LIGHT" | "SVG_BLUE" | "SVG_BLUE2" | "SVG_LINES_BLUE" | "SVG_LINES_GREEN" | "SVG_LINES_ORANGE" | "SVG_LINES_PURPLE" | "SVG_LINES_SALMON" | "SVG_LINES_YELLOW" | "SVG_WHITE" | "SVG_WHITE2" | "SVG_YELLOW" | "SVG_YELLOW2" | "VAPOR_GRADIENT_BLUE_DARK" | "VAPOR_GRADIENT_BLUE_LIGHT" | "VAPOR_GRADIENT_GREEN_DARK" | "VAPOR_GRADIENT_GREEN_LIGHT" | "VAPOR_GRADIENT_PURPLE_DARK" | "VAPOR_GRADIENT_PURPLE_LIGHT" | "VAPOR_GRADIENT_SALMON_DARK" | "VAPOR_GRADIENT_SALMON_LIGHT" | "VAPOR_GRADIENT_WATERMELON_DARK" | "VAPOR_GRADIENT_WATERMELON_LIGHT" | "VAPOR_GRADIENT_WHITE_DARK" | "VAPOR_GRADIENT_YELLOW_LIGHT" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type BlogCard_portfolioProject$data = {
  readonly analyticsId: number;
  readonly author: {
    readonly id: string;
  } | null;
  readonly blogCategories: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly name: string;
      };
    }>;
  } | null;
  readonly contentImages: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly animated: boolean;
        readonly height: number;
        readonly id: string;
        readonly originalFormat: string;
        readonly sizeBytes: number;
        readonly uid: string;
        readonly width: number;
      };
    }>;
  };
  readonly cover: {
    readonly __typename: "PortfolioProjectImageCover";
    readonly image?: {
      readonly animated: boolean;
      readonly height: number;
      readonly id: string;
      readonly originalFormat: string;
      readonly sizeBytes: number;
      readonly uid: string;
      readonly width: number;
    };
    readonly style?: PortfolioProjectTextCoverStyle;
    readonly " $fragmentSpreads": FragmentRefs<"ProjectCoverWrapper_portfolioProjectCover">;
  };
  readonly description: string | null;
  readonly id: string;
  readonly slug: string;
  readonly title: string;
  readonly " $fragmentType": "BlogCard_portfolioProject";
};
export type BlogCard_portfolioProject$key = {
  readonly " $data"?: BlogCard_portfolioProject$data;
  readonly " $fragmentSpreads": FragmentRefs<"BlogCard_portfolioProject">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v2 = [
  (v0/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "animated",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "height",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "originalFormat",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "sizeBytes",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "uid",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "width",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "BlogCard_portfolioProject",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "analyticsId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "UserProfile",
      "kind": "LinkedField",
      "name": "author",
      "plural": false,
      "selections": [
        (v0/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "BlogCategoryConnection",
      "kind": "LinkedField",
      "name": "blogCategories",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "BlogCategoryEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "BlogCategory",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "name",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "slug",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "cover",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "ProjectCoverWrapper_portfolioProjectCover"
        },
        {
          "kind": "InlineFragment",
          "selections": [
            (v1/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "ContraImage",
              "kind": "LinkedField",
              "name": "image",
              "plural": false,
              "selections": (v2/*: any*/),
              "storageKey": null
            }
          ],
          "type": "PortfolioProjectImageCover",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            (v1/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "style",
              "storageKey": null
            }
          ],
          "type": "PortfolioProjectTextCover",
          "abstractKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "PortfolioProjectContentImageConnection",
      "kind": "LinkedField",
      "name": "contentImages",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "PortfolioProjectContentImageEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "ContraImage",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": (v2/*: any*/),
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "PortfolioProject",
  "abstractKey": null
};
})();

(node as any).hash = "99cc15ac14790581ab4d0c093210cfd3";

export default node;
